import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeft,
  faPause,
  faStop,
} from '@fortawesome/free-solid-svg-icons';

const AdaptiveFlowHeroMock = () => (
  <div className="rounded-lg overflow-hidden shadow-2xl shadow-black/30 border border-white/[0.06] font-mono" style={{ background: '#0a0e14' }}>
    {/* Top bar -- matches AdaptiveFlowTopBar.tsx */}
    <div className="h-[72px] bg-[#0c1520] border-b border-white/[0.06] flex items-center justify-between px-6">
      {/* Left: Strategy Identity */}
      <div className="flex items-center gap-4">
        <span className="p-2 text-gray-400">
          <FontAwesomeIcon icon={faArrowLeft} />
        </span>
        <div className="flex flex-col">
          <div className="flex items-center gap-2">
            <span className="text-white font-semibold">BTCUSDT</span>
            <span className="text-gray-400">&middot;</span>
            <span className="text-gray-300">1d</span>
            <span className="text-gray-400">&middot;</span>
            <span className="text-cyan-400 font-mono font-medium">$67,160.71</span>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <span className="text-gray-400">EMA Crossover Project</span>
            <span className="text-gray-500">v1</span>
          </div>
        </div>
      </div>

      {/* Right: KPIs + Status + Controls */}
      <div className="flex items-center gap-4">
        <div className="flex flex-col items-center px-4">
          <span className="text-2xl font-bold text-emerald-400 flex items-center">7.4<span className="text-emerald-500/60 text-sm ml-1">&uarr;</span></span>
          <span className="text-xs text-gray-400 uppercase tracking-wide">Health Score</span>
        </div>
        <div className="flex flex-col items-center px-4">
          <span className="text-2xl font-bold text-white">78%</span>
          <span className="text-xs text-gray-400 uppercase tracking-wide">Confidence</span>
        </div>
        <span className="flex items-center gap-1.5 px-2 py-1 rounded" style={{ background: 'rgba(16,185,129,0.1)' }}>
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
          <span className="text-[10px] text-gray-300">Active</span>
        </span>
        <span className="flex items-center gap-1">
          <span className="flex items-center gap-1 px-2 py-1 text-[10px] text-gray-400 border border-gray-600/30 rounded">
            <FontAwesomeIcon icon={faPause} className="text-[9px]" /> Pause
          </span>
          <span className="flex items-center gap-1 px-2 py-1 text-[10px] text-gray-400 border border-gray-600/30 rounded">
            <FontAwesomeIcon icon={faStop} className="text-[9px]" /> Stop
          </span>
        </span>
      </div>
    </div>

    {/* Expected vs Actual Panel -- matches ExpectedVsActualPanel.tsx */}
    <div className="bg-[#181825] border border-white/[0.06] rounded-lg p-4 m-3">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium text-white uppercase tracking-wide">
          Live Performance vs Expected
        </h3>
        <div className="text-sm text-gray-400">
          Live Trades: <span className="text-white font-medium">12</span>
        </div>
      </div>

      <div className="flex gap-3 overflow-x-auto mb-3">
        {[
          { label: 'Win Rate', expected: '40.0%', range: '40.0% - 40.0%', actual: '41.7%', color: 'text-emerald-400' },
          { label: 'Sharpe Ratio', expected: '1.00', range: '0.99 - 1.02', actual: '1.12', color: 'text-emerald-400' },
          { label: 'Max Drawdown', expected: '21.9%', range: '21.9% - 21.9%', actual: '14.2%', color: 'text-emerald-400' },
          { label: 'Profit Factor', expected: '4.64', range: '3.72 - 5.57', actual: '3.91', color: 'text-white' },
          { label: 'Avg Return/Trade', expected: '26.8%', range: '26.8% - 27.1%', actual: '28.3%', color: 'text-emerald-400' },
        ].map((m) => (
          <div key={m.label} className="bg-white/[0.03] rounded-lg p-3 flex-1 min-w-[120px]">
            <div className="text-xs text-gray-400 uppercase tracking-wide mb-1">{m.label}</div>
            <div className="flex items-baseline gap-2">
              <span className="text-lg font-semibold text-white">{m.expected}</span>
              <span className="text-xs text-gray-500">({m.range})</span>
            </div>
            <div className="mt-1 flex items-center gap-2">
              <span className="text-xs text-gray-500">Actual:</span>
              <span className={`text-sm font-medium ${m.color}`}>{m.actual}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="text-sm text-emerald-400">
        Within expected range &mdash; all metrics within validation bounds.
      </div>
    </div>
  </div>
);

export default AdaptiveFlowHeroMock;
